import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import Index from './components/Index';
import Servicos from './components/Servicos';
import Contato from './components/Contato';

function App() {
  return (
      <Router>
        <div className="App">
              <Header/>

              <Routes>
                 <Route path="/" element={<Index/>} />
                 <Route path="/servicos" element={<Servicos/>} />
                 <Route path="/contato" element={<Contato/>} />
              </Routes>

              <Footer/>
        </div>


      </Router>

    
  );
}

export default App;
